export const errorConstants = {
    LINK_INVALIDO: 2,
    LINK_VENCIDO: 1,
    NO_CONTROLADO:3,
    SESION_VENCIDA:4
};
